import riderMessages from 'core/data-model/constants/validation-messages'

export const checkNatureOfDutyRule = (rule, eligibilities) => {
  let errorMessage = ''

  if (eligibilities.insured.occupation && eligibilities.insured.occupation.natureOfDutyCode === rule.natureOfDutyCode) {
    errorMessage = riderMessages.RULE_MESSAGE_NOT_FOUND
  }
  return {
    type: rule.validationType,
    message: errorMessage,
  }
}
